import PropTypes from 'prop-types';
import React from 'react';

import { Container } from 'components/Grid';
import RichText from 'components/RichText';
import CollectionBreadcrumbs from 'containers/CollectionBreadcrumbsContainer';
import CollectionDeadEnd from 'containers/CollectionDeadEndContainer';
import CollectionFilterPane from 'containers/CollectionFilterPaneContainer';
import CollectionsCarouselRecsContainer from 'containers/CollectionsCarouselRecsContainer';
import CollectionSecondaryNavigation from 'containers/CollectionSecondaryNavigationContainer';
import Faq from 'containers/FaqContainer';
import PillToggle from 'containers/PillToggleContainer';
import Theme from 'styles/theme';

const DesktopLayout = ({
  children,
  descriptionModule,
  hasSecondaryNavigationOptions,
  showPillToggle,
  leftPillToggle,
  rightPillToggle,
  isFiltering,
  faq,
}) => (
  <div className="DesktopLayout">
    <div className="DesktopLayout__content">
      <div className="DesktopLayout__section DesktopLayout__section--sidebar">
        <div className="DesktopLayout__navigation">
          <div className="DesktopLayout__breadcrumbs">
            <CollectionBreadcrumbs />
          </div>
          {hasSecondaryNavigationOptions && (
            <div className="DesktopLayout__secondary-nav-options">
              <CollectionSecondaryNavigation />
            </div>
          )}
        </div>
        <div className="DesktopLayout__filter-pane">
          <CollectionFilterPane />
        </div>
      </div>

      <div className="DesktopLayout__section DesktopLayout__section--main">
        {showPillToggle && !isFiltering && (
          <div className="DesktopLayout__unisex-toggle-container">
            <div className="DesktopLayout__unisex-toggle">
              <PillToggle leftPillToggle={leftPillToggle} rightPillToggle={rightPillToggle} />
            </div>
          </div>
        )}
        <div className="DesktopLayout__results">{children}</div>
      </div>
    </div>

    <CollectionsCarouselRecsContainer />

    {hasSecondaryNavigationOptions && (
      <div className="DesktopLayout__dead-end">
        <CollectionDeadEnd />
      </div>
    )}

    {descriptionModule && (
      <Container className="DesktopLayout__description-module-container">
        <RichText content={descriptionModule} />
      </Container>
    )}

    <div className="DesktopLayout__faq">
      <Faq {...faq} />
    </div>
    <style jsx>
      {`
        .DesktopLayout {
          margin-top: ${Theme.get('spacing') * 8}px;
        }

        .DesktopLayout__content {
          max-width: ${Theme.get('container-width-max-px')};
          margin: 0 auto;
          padding-left: ${Theme.get('spacing') * 4}px;
        }

        .DesktopLayout__section {
          display: inline-block;
          vertical-align: top;
        }

        .DesktopLayout__filters {
          padding-right: ${Theme.get('spacing') * 4}px;
        }

        .DesktopLayout__section--sidebar {
          width: 23%;
          padding: ${Theme.get('spacing')}px ${Theme.get('spacing') * 4}px
            ${Theme.get('spacing') * 4}px ${Theme.get('spacing') * 0}px;
        }

        .DesktopLayout__section--main {
          width: 77%;
        }

        .DesktopLayout__unisex-toggle-container {
          position: relative;
          margin-right: ${Theme.get('spacing') * 4}px;
        }

        .DesktopLayout__unisex-toggle {
          display: flex;
          justify-content: flex-end;
        }

        .DesktopLayout__navigation {
          margin-bottom: ${Theme.get('spacing') * 6}px;
        }

        .DesktopLayout__breadcrumbs,
        .DesktopLayout__secondary-nav-options,
        .DesktopLayout__filter-pane {
          margin-bottom: ${Theme.get('spacing') * 2}px;
        }

        .DesktopLayout__results {
          margin-left: ${Theme.get('spacing') * 4}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .DesktopLayout .CollectionFilters.CollectionFilters {
          margin: 0;
        }

        .DesktopLayout .DesktopLayout__faq .Container {
          padding: 0 ${Theme.get('spacing') * 12}px;
        }

        .DesktopLayout__description-module-container.Container {
          padding: ${Theme.get('spacing') * 9}px ${Theme.get('spacing') * 12}px;
        }

        .DesktopLayout__description-module-container.Container .typography--secondary-heading {
          margin-bottom: ${Theme.get('spacing') * 4}px;
        }
      `}
    </style>
  </div>
);

DesktopLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  hasSecondaryNavigationOptions: PropTypes.bool,
  showPillToggle: PropTypes.bool,
  leftPillToggle: PropTypes.shape({}),
  rightPillToggle: PropTypes.shape({}),
  isFiltering: PropTypes.bool,
  faq: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({}),
      })
    ),
  }),
  descriptionModule: PropTypes.shape({}),
};

DesktopLayout.defaultProps = {
  children: null,
  leftPillToggle: {},
  rightPillToggle: {},
  isFiltering: false,
  hasSecondaryNavigationOptions: false,
  faq: null,
  descriptionModule: null,
};

export default DesktopLayout;
